import React from 'react'

export default function Personel() {
  return (
    <div>personel</div>
  )
}
